import React from "react";
import PageWrapperComponent from "@src/components/organisms/page-wrapper/page-wrapper.component";
import PageHeadComponent from "@src/components/organisms/page-head/page-head.component";
import FeatherIcon from "feather-icons-react";
import FormBuilderComponent from "@molecules/form-builder/form-builder.component";
import CardComponent from "@atoms/card/card.component";
import { breadCrumbs } from "../banner-list/model/banner-list.constants";

const ActionContent = ({ handleSaveClick, handleBackClick }) => {
    return (
      <>
        <button
          type="button"
          className="btn btn-primary btn-sm"
          onClick={handleSaveClick}
        >
          <FeatherIcon icon="save" size={17} />
        </button>
  
        <button
          type="button"
          className="btn btn-outline-primary btn-sm ml-2"
          onClick={handleBackClick}
        >
          <FeatherIcon icon="arrow-left" size={17} />
        </button>
      </>
    );
  };

const BannerEditTemplateComponent = ({
  templateModal: { 
    formInputs, 
    formTriggers, 
  },
  templateEvents: { 
    handleSubmit, 
    handleTriggerClick, 
    handleBackClick 
  },
}) => {
  return (
    <PageWrapperComponent>
      <PageHeadComponent
        title={"Edit Banner"}
        breadCrumbs={[
            ...breadCrumbs,
            { name: "Edit ", menu_url: "/design/banners/edit" },
          ]}
        actionContent={
          <ActionContent
            handleSaveClick={() => handleTriggerClick("SUBMIT")}
            handleBackClick={handleBackClick}
          />
        }
      />

      {/* <CardComponent> */}
          <FormBuilderComponent
            formType={"group"}
            inputFields={formInputs}
            submitTrigger={formTriggers.submitTrigger}
            onSubmit={handleSubmit}
          />
      {/* </CardComponent> */}
    </PageWrapperComponent>
  );
};

export default BannerEditTemplateComponent;